import xhqUser from "./xhqUser";

export default xhqUser;
